export const OFFER_CONTRACT = "offer-contract";
export const REQUEST_SIGN = "request-sign";
export const SIGN = "sign";

const offerContractModel = {
  displayName: "",
  signUrl: "",
  status: "",
  fileData: {
    jsonApi: "hasOne",
    type: "file"
  }
};

export const offerContractActions = [SIGN, REQUEST_SIGN];

export default offerContractModel;
